module.exports = __webpack_public_path__ + "img/12.fa0d5a6e.png";